import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from '@app/core';

@Injectable()
export class CreationValueOperactionDataService{

  constructor(private http: HttpClient,
    private api: EndpointService){}

  
  /**
   *Obtiene las consultas disponibles para operaciones
   *
   * @return {*}  {Promise<any[]>}
   * @memberof CreationValueOperactionDataService
   */
  getSearchs(): Promise<any[]> {
    return new Promise((resolve, reject) =>{
      this.http.get<any[]>(this.api.get('adminFieldSearch')).subscribe(
        search => {
          let searchsField: any[] = [];
          search.forEach(element => {
            searchsField.push({ key: element.nombre, value: element.nombre });
          });
          resolve(searchsField);
        },
        err => {
          reject([]);
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/operations-form/creation-operation/creation-operation-value/shared/creation-operation-value.data.service.ts